import clsx from 'clsx'
import { useRouter } from 'next/router'
import Head from 'next/head'

import { Button } from '@wartek-id/button-v1'
import { historyUtils } from '@wartek-id/toolbox-helper'
import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarRightAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

interface PemetaanKompetensiPageHeaderProps {
  title: string
  icon?: string
  subtitle?: string
  rightActionLabel?: string
  withoutShadow?: boolean
  rightActionFunction?: Function
  leftActionFunction?: Function
  className?: string
  hideRightAction?: boolean
}

const PageHeader = ({
  title,
  icon = 'arrow_back',
  subtitle = '',
  rightActionLabel = '',
  rightActionFunction,
  leftActionFunction,
  withoutShadow = false,
  className = '',
  hideRightAction = false,
}: PemetaanKompetensiPageHeaderProps) => {
  const router = useRouter()

  return (
    <HeaderBar
      fixed
      className={clsx(
        'z-10 header-ujikom',
        withoutShadow && '!shadow-none',
        className
      )}
    >
      <Head>
        <title>{title || 'Refleksi Kompetensi'}</title>
      </Head>
      <HeaderBarLeftAction
        icon={
          <Icon as="i" color="default">
            {icon}
          </Icon>
        }
        onClick={
          leftActionFunction
            ? () => leftActionFunction()
            : () => historyUtils.backToApp(() => router.back())
        }
      />
      <HeaderBarTitle subtitle={subtitle}>{title}</HeaderBarTitle>
      {!hideRightAction && !!rightActionLabel && (
        <HeaderBarRightAction
          type="text"
          className="one-line-action cursor-pointer"
          onClick={() => rightActionFunction()}
        >
          {rightActionLabel}
        </HeaderBarRightAction>
      )}

      {!hideRightAction && !rightActionLabel && (
        <HeaderBarRightAction>
          <Button
            iconOnly
            size="md"
            variant="ghost"
            className="!h-9 !w-9"
            onClick={() => {
              window.open(
                'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us/sections/21276693559833-Refleksi-Kompetensi?focus=true',
                '_blank'
              )
            }}
          >
            <Icon as="i" color="inherit">
              info_outlined
            </Icon>
          </Button>
        </HeaderBarRightAction>
      )}
    </HeaderBar>
  )
}

export default PageHeader
